import React, { Component } from 'react';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
// import Icon from '@vzrf/react-icon';
import CloseIcon from '@vds/icons/close';
import { breakpoints } from '@vzrf/react-theme-helpers';


const SelectedChannelList = styled.div`
    display: flex;
    justify-content: center;
    margin: ${calculateRem(0, 10, 20)};
    @media only screen and (min-width: ${breakpoints.md}) {
        margin-bottom: ${calculateRem(0)};
        margin-top:1em;
      };
    @media only screen and (max-width:767px) {
       margin-bottom: 1em;
    }; 
`;

const SelectedChannelListRskn = styled.div`
    display: flex;
    justify-content: center;
    margin: ${calculateRem(0, 10, 20)};
    @media only screen and (min-width: ${breakpoints.md}) {
        margin-bottom: ${calculateRem(0)};
        margin-top:1em;
      };
    @media only screen and (max-width:767px) {
       margin-bottom: 1em;
    }; 
`;

const SelectedChannelItem = styled.div`
    width: ${calculateRem(63)};
    height: ${calculateRem(63)};
    background-color: #ffffff;
    margin-right: ${calculateRem(10)};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 2px;
    ${({ active }) => active && `
        border: 1px solid lightgray;
    `}

    &:last-child {
        margin-right: 0;
      }
`;

const SelectedChannelItemRskn = styled.div`
    width: ${calculateRem(63)};
    height: ${calculateRem(63)};
    background-color: #ffffff;
    margin-right: ${calculateRem(10)};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 2px;
    ${({ active }) => active && `
        border: 1px solid lightgray;
        border-radius: 8px;
    `}

    &:last-child {
        margin-right: 0;
      }
`;

const RemoveButton = styled.button`
    background: transparent;
    border: 0;
    position: absolute;
    right: 0;
    top: 0;
    padding: 3px;
    margin: 0;
    display: flex;
    cursor: pointer;
`;

const RemoveButtonRskn = styled.button`
    background: transparent;
    border: 0;
    position: absolute;
    left: 0;
    top: 0;
    padding: 3px;
    margin: 0;
    display: flex;
    cursor: pointer;
`;

let selectedChannelsDisplayList = [];


class SelectedChannelsDisplay extends Component {

    constructor(props) {
        super(props);
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }
    reviewChannelList = (screen) => {
        this.props.onReview('pickChannels');  
    }

    getSelectedChannels = () => {
        selectedChannelsDisplayList = [];
        for (var i = 0; i < 5; i++) {
            const isDisplayHasChannel = this.props.selectedChannels.length >= i+1;
            selectedChannelsDisplayList.push({
                id: isDisplayHasChannel ? this.props.selectedChannels[i].id : 'empty-' + i+1,
                name: isDisplayHasChannel ? this.props.selectedChannels[i].name : '',
                logo: isDisplayHasChannel ? this.props.channelImgPath + this.props.selectedChannels[i].logo  : '',
                ishasChannel: isDisplayHasChannel   
            });
        }                
    }

    removeSelectedChannel = (channelIndex) => {
        const selectedChannels = this.props.selectedChannels;
        this.props.removeChannel(selectedChannels[channelIndex])
    }


    render() {
        this.getSelectedChannels();
        return (            
            <React.Fragment> 
                {this.isReskin ?         
                    <SelectedChannelListRskn>
                        {
                            selectedChannelsDisplayList.map((channel, index) => 
                            <SelectedChannelItemRskn  key={channel.id} active={channel.ishasChannel}>
                                {channel.ishasChannel ? <RemoveButtonRskn tabIndex='0' aria-label={`Remove Selected ${channel.name} Channel`} onClick={() => this.removeSelectedChannel(index)}><CloseIcon size="10" /></RemoveButtonRskn>: null }
                                {channel.ishasChannel ? <img alt={channel.name} src={channel.logo} width="45px" />: null }        
                            </SelectedChannelItemRskn>)
                        }
                    </SelectedChannelListRskn>
                :
                    <SelectedChannelList>
                        {
                            selectedChannelsDisplayList.map((channel, index) => 
                            <SelectedChannelItem  key={channel.id} active={channel.ishasChannel}>
                                {channel.ishasChannel ? <RemoveButton tabIndex='0' aria-label={`Remove Selected ${channel.name} Channel`} onClick={() => this.removeSelectedChannel(index)}><CloseIcon size="10" /></RemoveButton>: null }
                                {channel.ishasChannel ? <img alt={channel.name} src={channel.logo} />: null }        
                            </SelectedChannelItem>)
                        }
                    </SelectedChannelList>
                }
            </React.Fragment>
        );
    }
}

export default SelectedChannelsDisplay;